module.exports = __webpack_public_path__ + "static/img/namaste.a1f00e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/namaste.png
// module id = uZv+
// module chunks = 0